import { CategoryFiltersView } from "./category-filters";
import { SearchDownloadModel, DownloadMode } from "./../models/search-download";
import { GenericDownloadView } from "./../../desktop/views/partials/generic-download";
import { MaterialFilterView } from "./material-filter";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {SearchModel} from "../models/search";

const template = require<string>("./category-filter-panel.html");

const dom = {
    ALL_CATEGORIES_LINK: ".all-categories-link"
};

@backboneViewProperties({
    template: template,
    tagName: "div",
    className: "categories-filter",
})
export class CategoryFilterPanelView extends Marionette.LayoutView<any> {

    public model: SearchModel;
    private listRegion: Marionette.Region;
    private listView: any;

    constructor(options?: any) {
        super(options);
        this.listenTo(this.model.MaterialFacets, "change:Ticked", this.materialFiltersChanged);

    }

    public materialFiltersChanged() {

        const currentMatFilters = this.model.getActiveMaterialFilters();

        if (currentMatFilters && currentMatFilters.length !== 0 && !_.contains(currentMatFilters, "Case")) { // if we're filtering by mat type, but not including cases
            $(this.el).addClass("disabled");
        } else {
            $(this.el).removeClass("disabled");
        }

    }

    public events(): Backbone.EventsHash   {
        const events: Backbone.EventsHash = {};

        events[`click ${dom.ALL_CATEGORIES_LINK}`] = (e) => this.allCategoriesLinkClicked(e);

        return events;
    }

    public allCategoriesLinkClicked(e: JQueryEventObject) {

        let anyChanged = false;
        this.model.CategoryFacets.forEach((m) => {
            if (m.Ticked) {
                anyChanged = true;
            }
            m.Ticked = false;
        });

        if (anyChanged) {
            _.defer(() => {

                this.model.setPage(1);
                this.model.emitSearchRequest();
            });
        }
    }
    public regions(): any {
        const regions = {
            listRegion: ".category-list-region"

        };
        return regions;
    }

    public onShow() {
        this.setupSubViews();
        this.listenTo(this.model.CategoryFacets, "change:Ticked", this.tickedChanged);
        this.tickedChanged();
    }

    public tickedChanged() {

        let allCheckboxVal = false;

        if (this.model.CategoryFacets.all((f) => !f.Ticked)) {
            allCheckboxVal = true;
        }

        _.defer(() => {
            this.$(dom.ALL_CATEGORIES_LINK).find("input").prop("checked", allCheckboxVal);
        });
    }

    public setupSubViews() {
        this.listView = new CategoryFiltersView({model: this.model, collection: this.model.CategoryFacets});
        this.listRegion.show(this.listView, {preventDestroy: true});
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/category-filter-panel.ts